import React, {useContext} from "react";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import "./dateAndTime.scss";
import {DatePicker} from "@mui/lab";
import {observer} from "mobx-react";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import EventIcon from "@mui/icons-material/Event";
import {ClickAwayListener} from "@mui/material";
import {storesContext} from "../../../../common/stores/stores";
import {UserStore} from "../../../../administration/stores/userStore";
import {DateUtils} from "../../../../helpers/dateUtils";

interface DateProps {
    testId: string;
    dateLabel: string;
    dateValue: ValidatedValue<Date | null>;
    onChangeDate?: (date: Date | null) => void;
    disabled?: boolean;
}

function Date(props: DateProps) {
    const userStore = useContext(storesContext).userStore as UserStore;
    const language = userStore.language;
    const [displayCalendar, setDisplayCalendar] = React.useState(false);
    const mask = DateUtils.dateMaskMap[language as keyof typeof DateUtils.dateMaskMap];

    return (
        <ClickAwayListener onClickAway={() => {closeCalendar();}}>
            <div className="date">
                <DatePicker
                    mask={mask}
                    label={props.dateLabel}
                    value={props.dateValue.value}
                    onChange={(newDate: Date | null) => {
                        props.dateValue.setValue(newDate);
                        if (props.onChangeDate) {
                            props.onChangeDate(newDate);
                        }
                        props.dateValue.clearValidation();
                        closeCalendar();
                    }}
                    open={displayCalendar}
                    renderInput={(params) => (
                        <TextInput
                            params={params}
                            label={props.dateLabel}
                            validatedValue={props.dateValue}
                            endIcon={
                                <EventIcon/>
                            }
                            onClickEndIcon={() => setDisplayCalendar(!displayCalendar)}
                            testId={props.testId}
                            withoutOnChange
                            disabled={props.disabled}
                            offAutocomplete
                        />
                    )}
                    disabled={props.disabled}
                />
            </div>
        </ClickAwayListener>
    );

    function closeCalendar(){
        setDisplayCalendar(false);
    }
}

export default observer(Date);
